module.exports = __webpack_public_path__ + "img/Packaging-1.eca238f3.svg";